import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  CircularProgress,
  IconButton,
  Box,
  Typography,
  useTheme
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";

import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMap
} from "react-leaflet";

import L from "leaflet";
import "leaflet/dist/leaflet.css";

// --------------------------------------
// FIX LEAFLET DEFAULT MARKER LOADING
// --------------------------------------
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

// --------------------------------------
// FIX MAP RESIZE INSIDE MUI DIALOG
// --------------------------------------
function FixMapResize() {

  const map = useMap();
  useEffect(() => {
    setTimeout(() => {
      map.invalidateSize();
    }, 300);
  }, [map]);
  return null;
}

// --------------------------------------
// CUSTOM BLINKING MARKER
// --------------------------------------
const blinkingIcon = new L.DivIcon({
  html: "<div class='blink-marker'></div>",
  iconSize: [20, 20],
  className: "",
});

// --------------------------------------
// MAIN DIALOG COMPONENT
// --------------------------------------
const IpLocationDialog = ({ open, onClose, ip }) => {
  const [location, setLocation] = useState(null);
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  // Fetch IP Info
  useEffect(() => {
    if (open && ip) {
      setLoading(true);
      axios
        .get(`https://ipapi.co/${ip}/json/`)
        .then((res) => setLocation(res.data))
        .catch((err) => console.error(err))
        .finally(() => setLoading(false));
    }
  }, [open, ip]);

  // Check invalid cases (private IP, missing coords)
  const notValid =
    !location ||
    location.error ||
    !location.latitude ||
    !location.longitude;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ fontSize: "20px", fontWeight: 700 }}>
        Geolocation for IP:{" "}
        <span style={{ background: theme.palette.primary.main, padding: "2px 6px", borderRadius: "2px", color: "white" }}>
          {ip}
        </span>
        <IconButton onClick={onClose} sx={{ position: "absolute", right: 10, top: 10 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ backgroundColor: "#111", color: "#fff" }}>
        {loading ? (
          <Box sx={{ height: 300, display: "flex", justifyContent: "center", alignItems: "center" }}>
            <CircularProgress />
          </Box>
        ) : notValid ? (
          <Typography color="error">No geolocation data available for this IP.</Typography>
        ) : (
          <>
            {/* MAP */}
            <Box
              sx={{
                height: 350,
                width: "100%",
                overflow: "hidden",
                borderRadius: 2,
                mb: 2
              }}
            >
              <MapContainer
                center={[location.latitude, location.longitude]}
                zoom={12}
                style={{ height: "100%", width: "100%" }}
              >
                <FixMapResize />

                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

                <Marker
                  position={[location.latitude, location.longitude]}
                  icon={blinkingIcon}
                >
                  <Popup>
                    {location.city}, {location.region}, {location.country_name}
                  </Popup>
                </Marker>
              </MapContainer>
            </Box>

            {/* DETAILS */}
            <Typography><strong>City:</strong> {location.city}</Typography>
            <Typography><strong>Region:</strong> {location.region}</Typography>
            <Typography><strong>Country:</strong> {location.country_name}</Typography>
            <Typography><strong>Latitude:</strong> {location.latitude}</Typography>
            <Typography><strong>Longitude:</strong> {location.longitude}</Typography>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default IpLocationDialog;
